import React, { useRef, useEffect } from 'react';
import { ToolTipPlacement, Tooltip } from '../tooltip/Tooltip';

export interface IOptions {
    value: string;
    label: string;
    isDisabled?: boolean;
    isSelected?: boolean;
}

export type ISelectOptions = IOptions[];

interface ISelectProps {
    // slots
    options: ISelectOptions;
    error?: string;
    hint?: string;
    label?: string;
    toolTipLabel?: string;
    // attributes
    dataTestId?: string;
    defaultOptionLabel?: string;
    describedBy?: string;
    isDisabled?: boolean;
    isError?: boolean;
    hideRequiredLabelling?: boolean;
    identifier?: string;
    hasNoDefaultOption?: boolean;
    quietValidate?: boolean;
    isRequired?: boolean;
    value: string;
    // attributes tooltip
    toolTipDescription?: string;
    toolTipPlacement?: ToolTipPlacement;
    fullWidth?: boolean;
    // events
    onChange?: (value: string) => void;
    onToolTipClick?: () => void;
}

export const Select: React.FC<ISelectProps> = ({
    // slots
    options,
    error,
    hint,
    label,
    toolTipLabel,
    // attributes
    dataTestId,
    defaultOptionLabel,
    describedBy,
    isDisabled = false,
    isError = false,
    hideRequiredLabelling = false,
    identifier,
    hasNoDefaultOption = false,
    quietValidate,
    isRequired = false,
    value,
    // attributes tooltip
    toolTipDescription,
    toolTipPlacement,
    fullWidth = false,
    // events
    onChange,
    onToolTipClick
}) => {
    const ref = useRef(null);

    const handleChange = (e: any) => {
        onChange(e?.detail?.value);
    };

    useEffect(() => {
        ref.current.addEventListener('dsdSelectChange', (e: any) => {
            if (onChange) handleChange(e);
        });
    }, []);

    return (
        //  @ts-ignore
        <dsd-select
            data-testid={dataTestId}
            ref={ref}
            identifier={identifier}
            disabled={isDisabled}
            error={isError}
            name={identifier}
            required={isRequired}
            value={value}
            default-option-label={defaultOptionLabel}
            describe-by={describedBy}
            hide-required-labelling={hideRequiredLabelling}
            no-default-option={hasNoDefaultOption}
            quiet-validate={quietValidate}
            style={fullWidth ? { minWidth: '100%' } : {}}
            label={label}
        >
            <span slot="label">{label}</span>
            <Tooltip
                label={toolTipLabel}
                description={toolTipDescription}
                placement={toolTipPlacement}
                onClick={onToolTipClick}
            />
            <span slot="hint">{hint}</span>
            <span slot="error">{error}</span>
            <span slot="options" data-testid={identifier + '_options'}>
                {options?.map((option, index) => (
                    <option
                        key={index}
                        value={option.value}
                        disabled={option.isDisabled}
                        data-testid={identifier + '_option_' + option.value}
                    >
                        {option.label}
                    </option>
                ))}
            </span>
            {/* @ts-ignore */}
        </dsd-select>
    );
};
